import { Component, OnInit } from '@angular/core';
import { EnvService } from '../env.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  pageNotFoundMessage: string;
  pageNotFoundHeader: string;

  constructor(private env:EnvService) { 
    
    this.pageNotFoundMessage = this.env.pageNotFoundMessage;
    this.pageNotFoundHeader = this.env.pageNotFoundHeader;
  }

  ngOnInit() {
  }

}
